export default __webpack_public_path__ + "static/media/menu-pelanggan.f4a4c249.svg";